import { MutableRefObject, useEffect, useRef } from 'react';
import { Box } from '../box';
import { CSS } from '@/stitches.config';

const SCROLL_PERCENTAGE_CSS_VAR = '--scrollPercentage';

interface ScrollProgressIndicatorProps {
  scrollableContainerRef: MutableRefObject<HTMLDivElement | null>;
  css?: CSS;
}

export function ScrollProgressIndicator({
  scrollableContainerRef,
  css,
}: ScrollProgressIndicatorProps) {
  const scrollIndicatorRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const scrollableContainer = scrollableContainerRef.current;
    const scrollIndicator = scrollIndicatorRef.current;

    if (!scrollableContainer || !scrollIndicator) return;

    const updateScrollPercentage = () => {
      scrollIndicator.style.setProperty(
        SCROLL_PERCENTAGE_CSS_VAR,
        `${
          (scrollableContainer.clientWidth + scrollableContainer.scrollLeft) /
          scrollableContainer.scrollWidth
        }`
      );
    };

    updateScrollPercentage();

    scrollableContainer.addEventListener('scroll', updateScrollPercentage);
    window.addEventListener('resize', updateScrollPercentage);

    return () => {
      scrollableContainer.removeEventListener('scroll', updateScrollPercentage);
      window.removeEventListener('resize', updateScrollPercentage);
    };
  }, [scrollableContainerRef]);

  return (
    <Box
      css={{
        position: 'relative',
        height: '$2',
        width: '$9',
        border: '1px solid $foreground',
        ...css,
      }}
    >
      <Box
        ref={scrollIndicatorRef}
        css={{
          position: 'absolute',
          inset: 0,
          background: '$foreground',
          transformOrigin: 'left',
          transform: `scaleX(var(${SCROLL_PERCENTAGE_CSS_VAR}))`,
        }}
      />
    </Box>
  );
}
